import { msg } from '@lingui/core/macro'
import { entityId } from '@pkg/db/schema'
import { defineEnum } from '@pkg/shared/utils/enum-builder'
import { z } from 'zod'

import { PatientRelation } from './PatientRelation'

export const CareLevelEnum = defineEnum({
  ONE: {
    label: msg`Pflegegrad 1`,
    description: msg`Geringe Beeinträchtigung der Selbstständigkeit oder der Fähigkeiten`,
  },
  TWO: {
    label: msg`Pflegegrad 2`,
    description: msg`Erhebliche Beeinträchtigung der Selbstständigkeit oder der Fähigkeiten`,
  },
  THREE: {
    label: msg`Pflegegrad 3`,
    description: msg`Schwere Beeinträchtigung der Selbstständigkeit oder der Fähigkeiten`,
  },
  FOUR: {
    label: msg`Pflegegrad 4`,
    description: msg`Schwerste Beeinträchtigung der Selbstständigkeit oder der Fähigkeiten`,
  },
  FIVE: {
    label: msg`Pflegegrad 5`,
    description: msg`Schwerste Beeinträchtigung der Selbstständigkeit oder der Fähigkeiten mit besonderen Anforderungen an die pflegerische Versorgung`,
  },
  NONE: {
    label: msg`Kein Pflegegrad vorhanden`,
    description: msg`Es liegt kein Pflegegrad vor, oder der Pflegegrad ist nicht bekannt.`,
  },
})

export type CareLevelType = typeof CareLevelEnum.$.Type

export const PatientCareLevelId = entityId('patientCareLevel')

export type PatientCareLevelIdType = typeof PatientCareLevelId.Type

export const PatientCareLevelRelationSchema = PatientRelation.extend({
  id: PatientCareLevelId.schema,
  level: z.enum(CareLevelEnum.$.zodEnum()),
})

export type PatientCareLevelRelation = z.infer<typeof PatientCareLevelRelationSchema>
